import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { toggleModal } from '../../redux/actions/modalActions';
import * as optimizelyUtil from '../../utils/optimizely';

import './BookHandLuggageModalLayout.desktop.scss';
import './BookHandLuggageModalLayout.mobile.scss';

const mapStateToProps = () => ({});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    toggleModalBound: bindActionCreators(toggleModal, dispatch),
  };
}

export class BookHandLuggageModalLayout extends Component {
  static propTypes = {
    toggleModalBound: PropTypes.func.isRequired,
    airlineBaggage: ImmutablePropTypes.mapContains({
      hand_weight: PropTypes.string.isRequired,
      hand_size: PropTypes.string.isRequired,
      hand_bags: PropTypes.number.isRequired,
    }).isRequired,
  }

  close = () => {
    const { toggleModalBound } = this.props;
    toggleModalBound();
  }

  render() {
    const { airlineBaggage } = this.props;
    optimizelyUtil.fireEvent('BookHandLuggageModal', 'displayed');

    return (
      <div className="book-hand-luggage-modal-layout">
        Most airlines now charge extra for hold luggage. Your booking includes {airlineBaggage.get('hand_bags')} hand luggage item per person.
        <div className="book-hand-luggage-modal-layout__details">
          <div className="book-hand-luggage-modal-layout__details__label">Hand luggage size:</div>
          <div className="book-hand-luggage-modal-layout__details__field">{airlineBaggage.get('hand_size')}</div>
        </div>
        <div className="book-hand-luggage-modal-layout__details">
          <div className="book-hand-luggage-modal-layout__details__label">Hand luggage max weight:</div>
          <div className="book-hand-luggage-modal-layout__details__field">{airlineBaggage.get('hand_weight').replace(' in one bag', '')}</div>
        </div>
        <button onClick={this.close} className="book-hand-luggage-modal-layout__close">Close</button>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookHandLuggageModalLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/BookHandLuggageModalLayout/BookHandLuggageModalLayout.jsx
 **/